import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import { NavLink } from 'react-router-dom';
import style from './BreadCrumbs.module.css.js';

const BreadCrumbs = ({ children }) => {
    const items = React__default.Children.toArray(children);
    return (jsx("div", { className: style.container, children: items.map((item, i) => (jsxs(React__default.Fragment, { children: [item, i < items.length - 1 && jsx("div", { className: style.separator, children: " / " })] }, i))) }));
};
const Crumb = ({ children, to, icon, onClick }) => {
    return (jsxs(NavLink, { to: to, className: style.crumb, onClick: onClick, children: [icon && icon, jsx("span", { className: style.crumbText, children: children })] }));
};

export { BreadCrumbs, Crumb };
//# sourceMappingURL=BreadCrumbs.js.map
